var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.37965 3.51493C3.60866 2.62459 4.43169 2 5.37589 2H18.6241C19.5683 2 20.3913 2.62459 20.6203 3.51493L21.9688 8.75746C22.1311 9.38861 21.64 10 20.9707 10H3.02934C2.36001 10 1.86889 9.38861 2.03123 8.75746L3.37965 3.51493Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11.5V21C4 21.5523 4.44772 22 5 22C5.55228 22 6 21.5523 6 21V13H18V21C18 21.5523 18.4477 22 19 22C19.5523 22 20 21.5523 20 21V11.5H4Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 14.5C7 14.2239 7.22386 14 7.5 14H10.5C10.7761 14 11 14.2239 11 14.5V16.5C11 16.7761 10.7761 17 10.5 17H7.5C7.22386 17 7 16.7761 7 16.5V14.5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 18C7.22386 18 7 18.2239 7 18.5V21.5C7 21.7761 7.22386 22 7.5 22H10.5C10.7761 22 11 21.7761 11 21.5V18.5C11 18.2239 10.7761 18 10.5 18H7.5Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18C12.2239 18 12 18.2239 12 18.5V21.5C12 21.7761 12.2239 22 12.5 22H15.5C15.7761 22 16 21.7761 16 21.5V18.5C16 18.2239 15.7761 18 15.5 18H12.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.8df1baa03528f6f021f889fb9826bcb9.svg";
export { ForwardRef as ReactComponent };